
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'shield': {
    width: 11.3,
    height: 15.4,
    viewBox: '0 0 11.3 15.4',
    data: '<path pid="0" d="M5.6 15.44l-.3-.2c-4.4-1.3-5.3-7-5.3-7.2v-4.7L5.5.04l.5.2 5.3 3.2v4.7c0 .3-.9 6-5.3 7.3h-.4zM1 8.04s.8 5.2 4.6 6.3c3.9-1.1 4.6-6.4 4.7-6.4v-4l-4.7-2.9L1 3.94v4.1z"/><path pid="1" d="M4.6 9.84c-.1 0-.3-.1-.4-.1L3 8.44c-.2-.2-.2-.5 0-.7.2-.2.5-.2.7 0l.9.9 2.9-2.9c.2-.2.5-.2.7 0s.2.5 0 .7L5 9.64c-.1.1-.2.2-.4.2z"/>'
  }
})
